import aulaTributariaLogo from '../assets/logo.svg'
import reunionTributariaLogo from '../assets/logo-reuniontributaria.png'

// La marca se elige en runtime con window.APP_CONFIG.brand (public/config.js)
const brands = {
  aulatributaria: {
    logo: aulaTributariaLogo,
    homeUrl: 'https://www.aulatributaria.cl/'
  },
  reuniontributaria: {
    logo: reunionTributariaLogo,
    homeUrl: 'https://reuniontributaria.aulatributaria.cl/'
  }
}

const config = window.APP_CONFIG || {}

export default brands[config.brand] || brands.aulatributaria
